// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2uwFP","iconWrap":"styles_iconWrap__2aKs1","stepWrap":"styles_stepWrap__VpSMa"};